import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IGroup } from "./getGroupList";

/**
 * 특정 그룹의 정보를 가져옵니다.
 * @param id 그룹 ID
 * @returns API 응답
 */
export const apiGetGroup = async (id: string) => {
  const response = await apiGet<IGroup>(`/groups/${id}`);
  return response;
};

/**
 * 특정 그룹의 정보를 React Query를 통해 가져오는 훅
 * @param id 그룹 ID
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetGroup = (id: string, options = {}) => {
  return useQuery({
    queryKey: QueryKeys.group.detail(id),
    queryFn: async () => {
      const response = await apiGetGroup(id);
      return response.data;
    },
    ...options,
  });
};

export default useQueryGetGroup;
